<template>
  <div>
    <Links
        :project="project"
    />
    <v-container class="pt-0">
      <v-card flat class="mb-3">
        <v-toolbar dark dense flat>
          <v-icon>mdi-view-dashboard-variant</v-icon> <span class="ml-2 ellipsify">Informações</span>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <ProjectDashboard
              v-if="project.id"
              :project_id="project.id"
              :project_tax="project.power_tax"
              :project_day_start="project.day_start"
          />
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ProjectDashboard from "./components/ProjectDashboard";
import Links from './components/Links';

export default {
  components: {
    ProjectDashboard,
    Links
  },
  mounted() {
    this.projectLoad();
  },
  data() {
    return {
      project: {
        power_tax: 0,
        day_start: 1,
        title: '',
      }
    }
  },
  methods: {
    projectLoad () {
      const payload = {
        project_id: this.$router.currentRoute.params.project_id,
        project_uid: this.$router.currentRoute.params.project_uid
      }

      this.$api
          .post('/project/project.info', payload)
          .then(response => {
            this.project = response.data;
          });
    }
  }
}
</script>

<style>

</style>